export enum TypeOfTravel {
  OneWay = 'ONE_WAY',
  TwoWay = 'TWO_WAY',
}
